import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/js/bootstrap.min.js';

// Explicit platform marker consumed by ecom-lib. This keeps the demo cart
// independent from Shopify while exercising the same confirmed add flow.
window.ModyEcom = { ...(window.ModyEcom || {}), platform: 'mody-ecom' }

createApp(App).use(store).use(router).mount('#app')
